/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { NoveltyCalcAffectedProduct } from './NoveltyCalcAffectedProduct';
import {
    NoveltyCalcAffectedProductFromJSON,
    NoveltyCalcAffectedProductFromJSONTyped,
    NoveltyCalcAffectedProductToJSON,
    NoveltyCalcAffectedProductToJSONTyped,
} from './NoveltyCalcAffectedProduct';

/**
 * 
 * @export
 * @interface NoveltyCalcErrorGroup
 */
export interface NoveltyCalcErrorGroup {
    /**
     * 
     * @type {string}
     * @memberof NoveltyCalcErrorGroup
     */
    message: string;
    /**
     * 
     * @type {Array<NoveltyCalcAffectedProduct>}
     * @memberof NoveltyCalcErrorGroup
     */
    affectedProducts: Array<NoveltyCalcAffectedProduct>;
}

/**
 * Check if a given object implements the NoveltyCalcErrorGroup interface.
 */
export function instanceOfNoveltyCalcErrorGroup(value: object): value is NoveltyCalcErrorGroup {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('affectedProducts' in value) || value['affectedProducts'] === undefined) return false;
    return true;
}

export function NoveltyCalcErrorGroupFromJSON(json: any): NoveltyCalcErrorGroup {
    return NoveltyCalcErrorGroupFromJSONTyped(json, false);
}

export function NoveltyCalcErrorGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoveltyCalcErrorGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'affectedProducts': ((json['affectedProducts'] as Array<any>).map(NoveltyCalcAffectedProductFromJSON)),
    };
}

export function NoveltyCalcErrorGroupToJSON(json: any): NoveltyCalcErrorGroup {
    return NoveltyCalcErrorGroupToJSONTyped(json, false);
}

export function NoveltyCalcErrorGroupToJSONTyped(value?: NoveltyCalcErrorGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'affectedProducts': ((value['affectedProducts'] as Array<any>).map(NoveltyCalcAffectedProductToJSON)),
    };
}

